import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSessionCustomer } from '../../customer';
import { usePet } from '../../pets';
import { useReporter } from '../../reporter';
import { ApiResult } from '../../api';
import { interpolateObject } from '../../cms';
import { ServerSideErrorModal } from '../../components';
import { QuizHeader } from '../QuizHeader';
import { interpolations } from './interpolation';
import { Main, Wrapper } from './styles';

export const QuizContainer = ({
  petId,
  totalSteps,
  goForward,
  goBack,
  goToLogin,
  step,
}) => {
  const customerApi = useSessionCustomer();
  const petApi = usePet(petId);
  const reporter = useReporter();
  const [showModal, setShowModal] = useState(false);

  const newProps = {
    ...interpolateObject(step.props, interpolations(petApi.pet)),
    index: step.index,
  };

  const currentQuestion = React.createElement(step.component, {
    ...newProps,
    ...step.extraProps,
    defaultValues: step.defaultValues,
    goBack,
    onSubmit: async formData => {
      const result = await step.saveForm(formData, {
        customerApi,
        petApi,
      });

      ApiResult.match(result, {
        success: payload => goForward(payload),
        error: {
          client: error => reporter.error(error.original),
          existingCustomer: () => goToLogin(),
          server: () => setShowModal(true),
        },
      });

      return result;
    },
  });

  return (
    <Wrapper>
      <QuizHeader currentStep={step.index + 1} totalSteps={totalSteps} />
      <Main>{currentQuestion}</Main>
      <ServerSideErrorModal
        shown={showModal}
        headerText="Hmm, something’s not right."
        errorMessage="We weren’t able to complete your request, please refresh the page and try again."
        onCloseModal={() => setShowModal(false)}
      />
    </Wrapper>
  );
};

QuizContainer.displayName = 'QuizContainer';

QuizContainer.propTypes = {
  petId: PropTypes.string.isRequired,
  totalSteps: PropTypes.number.isRequired,
  goForward: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  goToLogin: PropTypes.func.isRequired,
  step: PropTypes.shape({
    props: PropTypes.object.isRequired,
    extraProps: PropTypes.object,
    defaultValues: PropTypes.object.isRequired,
    component: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
